import { render, staticRenderFns } from "./horsesmouth.vue?vue&type=template&id=7dfd3e24"
import script from "./horsesmouth.vue?vue&type=script&lang=js"
export * from "./horsesmouth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports